/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import cx from 'classnames';
import Dotdotdot from 'react-dotdotdot';
import { translate } from 'react-i18next';

import { changeCurrentInfoEvent, filterInfoEvents } from '../Messages/actions';
import { SidebarFooter } from './SidebarFooter';
import { markAllEventsClick } from './actions';

const EVENT_GROUPS = ['Alarm', 'Technical', 'Information'];

const EVENT_TYPE_TO_CLASSNAME_MAP = {
  Alarm: 'triangle',
  Technical: 'hexagon',
  Information: 'circle',
  Logistic: 'circle',
};

@translate(['info-events-sidebar'], { wait: true })
class InfoEventsSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFilterId: -1,
      page: 0,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentWillMount() {
    this.loadMore(-1)
    if (this.props.hasMore && !this.props.infoEvents.length) {
      this.loadMore(this.state.currentFilterId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.infoEvents !== nextProps.infoEvents) {
      this.setState({
        fetching: false,
        refresh: false,
      });
    }
    if (
      this.props.currentDeviceId !== nextProps.currentDeviceId ||
      this.props.currentLanguage !== nextProps.currentLanguage
    ) {
      this.loadMore(this.state.currentFilterId);
    }
  }

  loadMore(filterId) {
    if (!this.props.readyToFetch) return;

    const { page, currentFilterId } = this.state;
    const refresh = typeof filterId === 'number';
    const nextFilterId = refresh ? filterId : currentFilterId;
    const nextPage = refresh ? 0 : page + 1;

    this.setState(
      {
        page: nextPage,
        fetching: true,
        currentFilterId: nextFilterId,
        refresh,
      },
      () => {
        this.props.filter({
          page: nextPage,
          groups:
            nextFilterId === -1 ? EVENT_GROUPS : [EVENT_GROUPS[nextFilterId]],
        });
      },
    );
  }

  render() {
    const { t, unreadEventsCount, infoEvents } = this.props;

    return (
      <aside className="aside">
        <div className="aside__filter aside__filter-messages">
          <ul className="filter-messages">
            <li className={cx({ active: this.state.currentFilterId === -1 })}>
              <a
                onClick={e => {
                  e.preventDefault();
                  this.loadMore(-1);
                }}
                href=""
              >
                <i className="ico icon_notice_all" />
                {t('info-events-sidebar:all')}
              </a>
            </li>
            <li className={cx({ active: this.state.currentFilterId === 0 })}>
              <a
                onClick={e => {
                  e.preventDefault();
                  this.loadMore(0);
                }}
                href=""
              >
                <i className="ico icon_notice_triangle" />
                {t('info-events-sidebar:warning')}
              </a>
            </li>
            <li className={cx({ active: this.state.currentFilterId === 1 })}>
              <a
                onClick={e => {
                  e.preventDefault();
                  this.loadMore(1);
                }}
                href=""
              >
                <i className="ico icon_notice_hexagon" />
                {t('info-events-sidebar:technical')}
              </a>
            </li>
            <li className={cx({ active: this.state.currentFilterId === 2 })}>
              <a
                onClick={e => {
                  e.preventDefault();
                  this.loadMore(2);
                }}
                href=""
              >
                <i className="ico icon_notice_circle" />
                {t('info-events-sidebar:info')}
              </a>
            </li>
          </ul>
        </div>
        <div
          className="aside-scroll"
          ref={el => {
            if (
              !el ||
              !this.props.hasMore ||
              this.state.fetching ||
              !this.props.infoEvents.length
            )
              return;
            const wrapperHeight = el.clientHeight;
            const contentHeight = el.firstElementChild.scrollHeight;
            if (wrapperHeight > contentHeight) {
              this.loadMore();
            }
          }}
        >
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (this.props.hasMore && !this.state.fetching) {
                this.loadMore();
              }
            }}
            hasMore={this.props.hasMore}
            loader={<div className="spinner" />}
            useWindow={false}
            initialLoad={false}
            threshold={10}
          >
            {unreadEventsCount > 0 && this.state.currentFilterId === -1 ? (
              <div className="mark-all">
                <a
                  role="button"
                  tabIndex="-1"
                  onClick={this.props.markAllEvents}
                >
                  {t('info-events-sidebar:read_all')}
                </a>
              </div>
            ) : null}
            {this.state.refresh
              ? null
              : infoEvents.map(infoEvent => {
                  const iconClassName = cx(
                    'ico',
                    `icon_notice_${
                      EVENT_TYPE_TO_CLASSNAME_MAP[EVENT_GROUPS[infoEvent.group]]
                    }`,
                    { icon_notice_opacity: infoEvent.isRead },
                  );
                  const time = moment().isSame(
                    moment(infoEvent.created * 1000),
                    'day',
                  )
                    ? moment(infoEvent.created * 1000).format('HH:mm')
                    : moment(infoEvent.created * 1000).format('DD/MM');

                  return (
                    <div
                      key={infoEvent.id}
                      className={cx('aside__item__notice', {
                        active: this.props.currentInfoEvent.id === infoEvent.id,
                      })}
                    >
                      <a
                        onClick={e => {
                          e.preventDefault();
                          this.props.changeInfoEvent(infoEvent);
                        }}
                        className="link"
                        href=""
                      />
                      <span className={iconClassName} />
                      <div className="time">{time}</div>
                      <Dotdotdot clamp={2} className="holder">
                        <div className="title">{infoEvent.header}</div>
                        <p>{infoEvent.text}</p>
                      </Dotdotdot>
                    </div>
                  );
                })}
          </InfiniteScroll>
        </div>
        <SidebarFooter />
      </aside>
    );
  }
}

InfoEventsSidebar.WrappedComponent.propTypes = {
  currentInfoEvent: PropTypes.object.isRequired,
  hasMore: PropTypes.bool.isRequired,
  readyToFetch: PropTypes.bool.isRequired,
  unreadEventsCount: PropTypes.number.isRequired,
  infoEvents: PropTypes.array.isRequired,
  currentDeviceId: PropTypes.number.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired,
  changeInfoEvent: PropTypes.func.isRequired,
  markAllEvents: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    infoEvents: state.infoEvents.infoEvents,
    currentInfoEvent: state.infoEvents.currentInfoEvent,
    hasMore: state.infoEvents.hasMore,
    readyToFetch: state.infoEvents.readyToFetch,
    unreadEventsCount: state.infoEvents.unreadEventsCount,
    currentDeviceId: state.devices.currentDevice.id,
    currentLanguage: state.langs.currentLanguage,
  }),
  dispatch => ({
    changeInfoEvent(infoEvent) {
      dispatch(changeCurrentInfoEvent({ infoEvent }));
    },
    filter(params) {
      return dispatch(filterInfoEvents(params));
    },
    markAllEvents() {
      return dispatch(markAllEventsClick());
    },
  }),
)(InfoEventsSidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/InfoEventsSidebar.js